(function () {
  if (window.FLPProductListsLoaded) return;
  window.FLPProductListsLoaded = true;

  var STORAGE_KEY = 'flp_product_lists_v1';
  var ACTIVE_KEY = 'flp_product_lists_active';
  var UPDATE_EVENT = 'flp-product-lists:updated';

  function safeParse(value, fallback) {
    try {
      var parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function readState() {
    var state = safeParse(localStorage.getItem(STORAGE_KEY), { lists: [], activeListId: '' });
    state.lists = Array.isArray(state.lists) ? state.lists : [];
    state.activeListId = typeof state.activeListId === 'string' ? state.activeListId : '';

    state.lists = state.lists
      .filter(function (list) {
        return list && typeof list === 'object';
      })
      .map(function (list) {
        list.items = Array.isArray(list.items) ? list.items : [];
        list.name = String(list.name || '').trim();
        list.id = String(list.id || '');
        list.createdAt = String(list.createdAt || new Date().toISOString());
        list.updatedAt = String(list.updatedAt || list.createdAt);
        return list;
      })
      .filter(function (list) {
        return list.id && list.name;
      });

    var storedActive = localStorage.getItem(ACTIVE_KEY);
    if (storedActive) state.activeListId = storedActive;

    return state;
  }

  function writeState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      if (state.activeListId) {
        localStorage.setItem(ACTIVE_KEY, state.activeListId);
      } else {
        localStorage.removeItem(ACTIVE_KEY);
      }
    } catch (error) {}

    window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: state }));
  }

  function makeId() {
    return String(Date.now()) + '-' + Math.random().toString(36).slice(2, 9);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (match) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[match];
    });
  }

  function getProductData(widget) {
    return {
      productId: widget.dataset.productId || '',
      handle: widget.dataset.productHandle || '',
      title: widget.dataset.productTitle || '',
      url: widget.dataset.productUrl || '',
      image: widget.dataset.productImage || '',
      price: widget.dataset.productPriceMoney || '',
      variantId: widget.dataset.productVariantId || '',
      vendor: widget.dataset.productVendor || ''
    };
  }

  function getProductKey(product) {
    return [product.productId || product.handle || 'product', product.variantId || 'default'].join('::');
  }

  function ensureList(state, name) {
    var normalizedName = String(name || '').trim();
    if (!normalizedName) return null;

    var existing = state.lists.find(function (list) {
      return list.name.toLowerCase() === normalizedName.toLowerCase();
    });

    if (existing) return existing;

    var newList = {
      id: makeId(),
      name: normalizedName,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      items: []
    };

    state.lists.unshift(newList);
    state.activeListId = newList.id;

    return newList;
  }

  function addProductToList(list, product) {
    list.items = Array.isArray(list.items) ? list.items : [];

    var productKey = getProductKey(product);
    var exists = list.items.some(function (item) {
      return getProductKey(item) === productKey;
    });

    if (!exists) {
      list.items.unshift(product);
    }

    list.updatedAt = new Date().toISOString();

    return !exists;
  }

  function renderPreview(container, product) {
    if (!container) return;

    container.innerHTML = [
      '<div class="flp-product-lists__preview-image">',
      product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span>Producto</span>',
      '</div>',
      '<div class="flp-product-lists__preview-copy">',
      '<strong>' + escapeHtml(product.title) + '</strong>',
      product.price ? '<span>' + escapeHtml(product.price) + '</span>' : '',
      product.vendor ? '<small>' + escapeHtml(product.vendor) + '</small>' : '',
      '</div>'
    ].join('');
  }

  function renderOptions(widget, state, product) {
    var container = widget.querySelector('[data-product-lists-options]');
    if (!container) return;

    if (!state.lists.length) {
      container.innerHTML = '<p class="flp-product-lists__empty-copy">Aún no tienes listas. Crea una nueva para guardar este producto.</p>';
      widget.dataset.selectedListId = '';
      return;
    }

    var selectedId = widget.dataset.selectedListId || state.activeListId || state.lists[0].id;
    widget.dataset.selectedListId = selectedId;

    container.innerHTML = state.lists
      .map(function (list) {
        var activeClass = list.id === selectedId ? ' is-active' : '';
        return [
          '<button type="button" class="flp-product-lists__option' + activeClass + '" data-product-list-option data-list-id="' + escapeHtml(list.id) + '">',
          '<span>' + escapeHtml(list.name) + '</span>',
          '<small>' + list.items.length + ' producto' + (list.items.length === 1 ? '' : 's') + '</small>',
          '</button>'
        ].join('');
      })
      .join('');

    container.querySelectorAll('[data-product-list-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        widget.dataset.selectedListId = button.dataset.listId;
        var nextState = readState();
        nextState.activeListId = button.dataset.listId;
        writeState(nextState);
        renderOptions(widget, nextState, product);
        renderFeedback(widget, '');
      });
    });
  }

  function renderFeedback(widget, message, tone) {
    var feedback = widget.querySelector('[data-product-list-feedback]');
    if (!feedback) return;

    if (!message) {
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.removeAttribute('data-tone');
      return;
    }

    feedback.hidden = false;
    feedback.textContent = message;
    feedback.setAttribute('data-tone', tone || 'info');
  }

  function openModal(widget) {
    var modal = widget.querySelector('[data-product-list-modal]');
    var input = widget.querySelector('[data-product-list-new-name]');
    if (!modal) return;

    modal.hidden = false;
    modal.classList.add('is-visible');
    widget.classList.add('is-open');
    widget.dataset.lastFocus = document.activeElement && document.activeElement.className ? document.activeElement.className : '';

    setTimeout(function () {
      if (input) input.focus();
    }, 0);
  }

  function closeModal(widget) {
    var modal = widget.querySelector('[data-product-list-modal]');
    var trigger = widget.querySelector('[data-product-list-trigger]');
    if (!modal) return;

    modal.classList.remove('is-visible');
    modal.hidden = true;
    widget.classList.remove('is-open');

    if (trigger) trigger.focus();
  }

  function setupWidget(widget) {
    if (widget.dataset.productListsInit === '1') return;
    widget.dataset.productListsInit = '1';

    var product = getProductData(widget);
    var state = readState();

    var trigger = widget.querySelector('[data-product-list-trigger]');
    var saveButton = widget.querySelector('[data-product-list-save]');
    var closeButtons = widget.querySelectorAll('[data-product-list-close]');
    var newNameInput = widget.querySelector('[data-product-list-new-name]');
    var preview = widget.querySelector('[data-product-preview]');

    renderPreview(preview, product);
    renderOptions(widget, state, product);

    if (trigger) {
      trigger.addEventListener('click', function () {
        state = readState();
        renderOptions(widget, state, product);
        renderFeedback(widget, '');
        openModal(widget);
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal(widget);
      });
    });

    if (newNameInput) {
      newNameInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (saveButton) saveButton.click();
        }
      });
    }

    if (saveButton) {
      saveButton.addEventListener('click', function () {
        var nextState = readState();
        var newName = newNameInput ? newNameInput.value.trim() : '';
        var targetList = null;

        if (newName) {
          targetList = ensureList(nextState, newName);
          if (targetList) {
            nextState.activeListId = targetList.id;
            if (newNameInput) newNameInput.value = '';
          }
        } else {
          var selectedId = widget.dataset.selectedListId || nextState.activeListId || (nextState.lists[0] && nextState.lists[0].id) || '';
          targetList = nextState.lists.find(function (list) {
            return list.id === selectedId;
          });
        }

        if (!targetList) {
          renderFeedback(widget, 'Elige una lista o escribe un nombre nuevo para crearla.', 'error');
          return;
        }

        var added = addProductToList(targetList, product);
        writeState(nextState);
        widget.dataset.selectedListId = targetList.id;
        renderOptions(widget, nextState, product);
        renderFeedback(
          widget,
          added ? 'Producto guardado en "' + targetList.name + '".' : 'Este producto ya estaba en "' + targetList.name + '".',
          added ? 'success' : 'info'
        );

        if (added && newName) {
          closeModal(widget);
        }
      });
    }
  }

  function formatPageItemCard(item, listId) {
    var imageHtml = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
      : '<span class="flp-product-lists-page__placeholder">Sin imagen</span>';

    return [
      '<article class="flp-product-lists-page__item">',
      '<a class="flp-product-lists-page__item-link" href="' + escapeHtml(item.url || '#') + '">',
      '<div class="flp-product-lists-page__item-media">' + imageHtml + '</div>',
      '<div class="flp-product-lists-page__item-copy">',
      '<strong>' + escapeHtml(item.title) + '</strong>',
      item.price ? '<span>' + escapeHtml(item.price) + '</span>' : '',
      '</div>',
      '</a>',
      '<button type="button" class="flp-product-lists-page__remove" data-product-lists-page-remove-item data-list-id="' + escapeHtml(listId) + '" data-item-key="' + escapeHtml(getProductKey(item)) + '">Quitar</button>',
      '</article>'
    ].join('');
  }

  function renderPage(container, state) {
    var content = container.querySelector('[data-product-lists-page-content]');
    var empty = container.querySelector('[data-product-lists-page-empty]');

    if (!content || !empty) return;

    var lists = (state.lists || []).slice().sort(function (a, b) {
      return new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0);
    });

    if (!lists.length) {
      content.innerHTML = '';
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    content.innerHTML = lists
      .map(function (list) {
        var itemsHtml = list.items && list.items.length
          ? list.items.map(function (item) {
              return formatPageItemCard(item, list.id);
            }).join('')
          : '<p class="flp-product-lists-page__list-empty">Esta lista todavía no tiene productos.</p>';

        return [
          '<article class="flp-product-lists-page__list">',
          '<div class="flp-product-lists-page__list-header">',
          '<div>',
          '<h2>' + escapeHtml(list.name) + '</h2>',
          '<p>' + list.items.length + ' producto' + (list.items.length === 1 ? '' : 's') + '</p>',
          '</div>',
          '<button type="button" class="flp-product-lists-page__delete" data-product-lists-page-delete-list data-list-id="' + escapeHtml(list.id) + '">Eliminar lista</button>',
          '</div>',
          '<div class="flp-product-lists-page__items">' + itemsHtml + '</div>',
          '</article>'
        ].join('');
      })
      .join('');

    content.querySelectorAll('[data-product-lists-page-remove-item]').forEach(function (button) {
      button.addEventListener('click', function () {
        var nextState = readState();
        var list = nextState.lists.find(function (entry) {
          return entry.id === button.dataset.listId;
        });

        if (!list) return;

        list.items = list.items.filter(function (item) {
          return getProductKey(item) !== button.dataset.itemKey;
        });
        list.updatedAt = new Date().toISOString();
        writeState(nextState);
        renderPage(container, nextState);
      });
    });

    content.querySelectorAll('[data-product-lists-page-delete-list]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!window.confirm('¿Eliminar esta lista?')) return;

        var nextState = readState();
        nextState.lists = nextState.lists.filter(function (entry) {
          return entry.id !== button.dataset.listId;
        });

        if (nextState.activeListId === button.dataset.listId) {
          nextState.activeListId = nextState.lists[0] ? nextState.lists[0].id : '';
        }

        writeState(nextState);
        renderPage(container, nextState);
      });
    });
  }

  function setupPage(container) {
    if (container.dataset.productListsPageInit === '1') return;
    container.dataset.productListsPageInit = '1';

    var newNameInput = container.querySelector('[data-product-lists-page-new-name]');
    var createButton = container.querySelector('[data-product-lists-page-create]');

    function rerender() {
      renderPage(container, readState());
    }

    renderPage(container, readState());

    if (createButton && newNameInput) {
      createButton.addEventListener('click', function () {
        var listName = newNameInput.value.trim();
        if (!listName) return;

        var nextState = readState();
        var list = ensureList(nextState, listName);
        if (list) {
          nextState.activeListId = list.id;
          writeState(nextState);
          newNameInput.value = '';
          renderPage(container, nextState);
        }
      });

      newNameInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          createButton.click();
        }
      });
    }

    window.addEventListener(UPDATE_EVENT, rerender);
    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY || event.key === ACTIVE_KEY) rerender();
    });
  }

  function init() {
    document.querySelectorAll('[data-product-lists-widget]').forEach(setupWidget);
    document.querySelectorAll('[data-product-lists-page]').forEach(setupPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
